import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppState } from '@services/core/app-state';
import { Observable, of } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { LOCALHOST } from '../tickets.config';

export interface RespSubirArchivo {
  urlPublica: string;
  name?: string;
  size?: number;
}

@Injectable({
  providedIn: 'root'
})
export class TicketsService {

  private readonly app = inject(AppState);

  private readonly envUrl = this.app.ENV.MTY_SICOP;
  private readonly defaultUrl = this.envUrl + '/ApisSeekopServices/api/Tickets';
  private readonly localUrl = 'http://localhost:8080/ApisSeekopServices/api/Tickets';
  private readonly configApiUrl = `${this.envUrl}/Api/Bot/getParametroDeSistema`;

  private useLocalhost = LOCALHOST; // Cambiar a true para usar localhost
  urlApi = this.useLocalhost ? this.localUrl : this.defaultUrl;
  private isInitialized = false;

  constructor(private http: HttpClient) {
    console.log('🎫 [TicketsService] URL inicial:', this.urlApi);
    console.log('URL enviroment:', this.envUrl);
  }

  initBaseUrl(idDistribuidor: string): Observable<void> {
    return this.getParametroSistema(idDistribuidor, 'TICKETS', 'URL_API').pipe(
      tap((resp) => {
        const urlFromApi = resp?.valor?.trim();
        this.urlApi = urlFromApi ? `${urlFromApi}/ApisSeekopServices/api/Tickets` : this.defaultUrl;
        this.isInitialized = true;
        console.log('🎫 [TicketsService] URL configurada:', this.urlApi);
        console.log('URL enviroment:', this.envUrl);
      }),
      map(() => { }),
      catchError(() => {
        this.urlApi = this.defaultUrl;
        this.isInitialized = true;
        console.log('🎫 [TicketsService] URL (fallback):', this.urlApi);
        return of(undefined);
      })
    );
  }

  private getParametroSistema(idDistribuidor: string, proceso: string, variable: string): Observable<any> {
    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('proceso', proceso)
      .set('variable', variable);

    return this.http.get(this.configApiUrl, { params });
  }

  getTickets(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getTickets`, payload);
  }

  getOrigen(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getOrigen`, payload);
  }

  getDistribuidores(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getDistribuidores`, payload);
  }

  getAreas(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getAreas`, payload);
  }

  getSubAreas(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getSubAreas`, payload);
  }

  getCategorias(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getCategorias`, payload);
  }

  getSubCategorias(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getSubCategorias`, payload);
  }

  getMarcas(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getMarcas`, payload);
  }

  getAutos(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getAutos`, payload);
  }

  getModelos(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getModelos`, payload);
  }

  getVersiones(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getVersiones`, payload);
  }

  insertTicket(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/insert`, payload);
  }

  updateTicket(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/updateTicket`, payload);
  }

  subirArchivoGoogle(file: File, idDistribuidor: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('idDistribuidor', idDistribuidor);
    formData.append('folder', 'quejas');

    return this.http.post<RespSubirArchivo>(
      `${this.envUrl}/ApisSeekopServices/api/SubirArchivos/google`,
      formData
    );
  }

  insertQueja(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/insertQueja`, payload);
  }

  insertProspecto(payload: any): Observable<any> {
    /* const baseUrl = this.envConfiguracion.get('URL_MONITOR'); */
    /* const baseUrl = 'https://www.sicopweb.com/'; */
    return this.http.post(`${this.envUrl}/Api/Bot/getAltaProspecto`, payload);
  }
  getActualizarDatosProspecto(payload: any): Observable<any> {
    /* const baseUrl = 'https://www.sicopweb.com/'; */
    return this.http.put(`${this.envUrl}/Api/Bot/getActualizarDatosProspecto`, payload);
  }

  updateProspecto(payload: any): Observable<any> {
    return this.http.put<any>(`${this.urlApi}/updateProspecto`, payload);
  }


  getProspecto(idDistribuidor: string, idProspecto: string): Observable<any> {

    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('idProspecto', idProspecto);
    /* const baseUrl = 'https://www.sicopweb.com/'; */
    return this.http.get(`${this.envUrl}/Api/Bot/getDatosProspecto`, { params });
  }

  getTicket(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getTicket`, payload);
  }

  getTicketsByProspecto(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getTicketsByProspecto`, payload);
  }

  getPerfiles(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getPerfiles`, payload);
  }

  getPuestos(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getPuestos`, payload);
  }

  getEjecutivosReasignar(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getEjecutivosReasignar`, payload);
  }

  getEjecutivoEscalar(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getEjecutivoEscalar`, payload);
  }

  updateQueja(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/updateQueja`, payload);
  }

  insertQuejaDetalle(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/insertQuejaDetalle`, payload);
  }

  insertQuejaParticipante(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/insertQuejaParticipante`, payload);
  }

  getParticipantes(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getParticipantes`, payload);
  }

  getArchivos(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getArchivos`, payload);
  }

  insertArchivosQueja(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/insertArchivosQueja`, payload);
  }

  getAutosMiddleware(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getAutosMiddleware`, payload);
  }

  getAutosSeminuevos(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getAutosSeminuevos`, payload);
  }

  getAsesores(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getAsesores`, payload);
  }

  getSubStatus(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getSubStatus`, payload);
  }

  getDealerOrigenByVIN(payload: any): Observable<any> {
    return this.http.post<any>(`${this.urlApi}/getDealerOrigenByVIN`, payload);
  }

}
